import api from './api';
import { downloadBinaryFile } from './fileDownload';

const REPORT_CACHE_PREFIX = 'reports:';

const reportService = {
  getDashboard: async () => {
    const response = await api.cachedGet('/reports/dashboard', {}, {
      cacheKey: `${REPORT_CACHE_PREFIX}dashboard`,
      ttlMs: 15 * 1000
    });
    return response.data;
  },

  getWeekly: async (startDate, endDate) => {
    const params = {
      start_date: startDate,
      end_date: endDate,
    };
    const response = await api.cachedGet('/reports/weekly', {
      params,
    }, {
      cacheKey: `${REPORT_CACHE_PREFIX}weekly:${startDate}:${endDate}`,
      ttlMs: 60 * 1000
    });
    return response.data;
  },

  getMonthly: async (year, month) => {
    const response = await api.cachedGet('/reports/monthly', {
      params: {
        year,
        month,
      },
    }, {
      cacheKey: `${REPORT_CACHE_PREFIX}monthly:${year}:${month}`,
      ttlMs: 60 * 1000
    });
    return response.data;
  },

  getTechnicianPerformance: async (startDate, endDate) => {
    const cacheKey = startDate && endDate
      ? `${REPORT_CACHE_PREFIX}technician-performance:${startDate}:${endDate}`
      : `${REPORT_CACHE_PREFIX}technician-performance:all-time`;

    const response = await api.cachedGet('/reports/technician-performance', {
      params: startDate && endDate ? { start_date: startDate, end_date: endDate } : {},
    }, {
      cacheKey,
      ttlMs: 60 * 1000
    });
    return response.data;
  },

  getOvertime: async (startDate, endDate) => {
    const cacheKey = startDate && endDate
      ? `${REPORT_CACHE_PREFIX}overtime:${startDate}:${endDate}`
      : `${REPORT_CACHE_PREFIX}overtime:all-time`;

    const response = await api.cachedGet('/reports/overtime', {
      params: startDate && endDate ? { start_date: startDate, end_date: endDate } : {},
    }, {
      cacheKey,
      ttlMs: 60 * 1000
    });
    return response.data;
  },

  getProjectReport: async (projectId) => {
    const response = await api.cachedGet(`/reports/project/${projectId}`, {}, {
      cacheKey: `${REPORT_CACHE_PREFIX}project:${projectId}`,
      ttlMs: 60 * 1000
    });
    return response.data;
  },

  downloadSolutionAttachment: async (ticketId) => {
    return downloadBinaryFile(
      api,
      `/tickets/${ticketId}/solution-attachment`,
      `ticket-${ticketId}-solution-attachment`
    );
  },
};

export default reportService;
